const Lead = () => {
  return (
    <section className="py-32 px-4 bg-background">
      <div className="max-w-4xl mx-auto">
        {/* 不規則な配置のテキスト */}
        <div className="space-y-12">
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-light text-left ml-0 md:ml-8">
            人が多い場所より、静かな方が落ち着く人向けです。
          </p>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-light text-right mr-0 md:mr-16">
            遊びとか、企画とか、日記とか。
          </p>
          <p className="text-base md:text-lg text-muted-foreground leading-relaxed font-light text-center mt-8">
            気が向いたときだけ、そっと置いていきます。
          </p>
        </div>
      </div>
    </section>
  );
};

export default Lead;